import { useState } from "react";
import { toast } from "sonner";
import { RotateCcw, Flag } from "lucide-react";
import { http, errMsg } from "../../lib/api";

const Act = ({ k, action, label, icon: Icon, reload }) => {
  const [busy, setBusy] = useState(false);
  const go = async (e) => {
    e.stopPropagation();
    const what = action === "retry" ? "stop this step and retry the kit from where it got to" : "skip what's left and mark the kit ready for review";
    if (!window.confirm(`${k.destination}: ${what}?`)) return;
    setBusy(true);
    try { const r = await http.post(`/kits/${k.id}/job-action`, { action }); toast.success(`${label} — ${r.data.message}`); reload(); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <button data-testid={`job-${action}-${k.id}`} onClick={go} disabled={busy}
      className="inline-flex items-center gap-1 rounded-sm border border-stone-300 bg-white px-2 py-1 text-xs hover:bg-stone-100 disabled:opacity-40 transition-colors">
      <Icon size={12} /> {label}
    </button>
  );
};

export const JobActions = ({ k, reload }) => k.pending_action
  ? <span data-testid={`job-pending-${k.id}`} className="text-xs text-sky-700">{k.pending_action === "retry" ? "Retrying…" : "Finishing…"}</span>
  : (
    <span className="inline-flex gap-1.5">
      <Act k={k} action="retry" label="Retry" icon={RotateCcw} reload={reload} />
      {k.sections > 0 && <Act k={k} action="finish" label="Finish as-is" icon={Flag} reload={reload} />}
    </span>
  );
